<div class="container">
  <div class="row">
    <div class="col-12">
      <lib-gung-tabset [destroyOnHide]="false" class="user-details-tabs" *ngIf="currentUser">
        <lib-gung-tab [title]="'USER' | translate">
          <ng-template libGungTabContent>
            <car-liner-user-details-user [currentUser]="currentUser"></car-liner-user-details-user>
          </ng-template>
        </lib-gung-tab>

        <lib-gung-tab [title]="'CUSTOMERS' | translate">
          <ng-template libGungTabContent>
            <car-liner-user-details-customers [currentUser]="currentUser"></car-liner-user-details-customers>
          </ng-template>
        </lib-gung-tab>

        <lib-gung-tab [title]="'SUBASSORTMENT' | translate">
          <ng-template libGungTabContent>
            <lib-user-details-subassortment [currentUser]="currentUser"></lib-user-details-subassortment>
          </ng-template>
        </lib-gung-tab>

        <lib-gung-tab [title]="'ORDER_PARAMS' | translate">
          <ng-template libGungTabContent>
            <lib-user-details-order-params [currentUser]="currentUser"></lib-user-details-order-params>
          </ng-template>
        </lib-gung-tab>

        <lib-gung-tab [title]="'SUPPLIERS' | translate">
          <ng-template libGungTabContent>
            <lib-user-details-managed-supplier [currentUser]="currentUser"></lib-user-details-managed-supplier>
          </ng-template>
        </lib-gung-tab>

        <lib-gung-tab [title]="'MFA' | translate">
          <ng-template libGungTabContent>
            <lib-user-details-mfa [currentUser]="currentUser"></lib-user-details-mfa>
          </ng-template>
        </lib-gung-tab>
      </lib-gung-tabset>
    </div>
  </div>
  <div class="text-center my-2" *ngIf="showError">
    {{ errorMessage }}
  </div>
  <div class="row justify-content-end pt-4">
    <div class="col-12">
      <div class="btn-group btn-group-justified w-100">
        <button type="button" class="btn btn-sm btn-warning" (click)="cancelChanges()">
          {{ 'CANCEL' | translate }}
        </button>
        <button type="button" class="btn btn-sm btn-primary" (click)="saveCurrentUser()" [disabled]="isLoading ? true : null">
          {{ 'SAVE_CHANGES' | translate }} <i *ngIf="isLoading" class="fas fa-spinner fa-spin"></i>
        </button>
      </div>
    </div>
  </div>
</div>
